/**
 * Runtime public path for Rspack: used for dynamically loaded assets (e.g. images).
 * Must be set before any asset URLs are resolved. Value is injected by the server
 * as window.__WEBPACK_PUBLIC_PATH__ when the app is served under a stage (e.g. /staging/).
 */
// eslint-disable-next-line no-undef
__webpack_public_path__ =
  typeof window !== "undefined" && window.__WEBPACK_PUBLIC_PATH__ != null
    ? window.__WEBPACK_PUBLIC_PATH__
    : "/";
